export { r as removeDuplicates } from '../removeDuplicates-e6360596.js';
export { D as DateComparer } from '../dateComparer-76f6c583.js';
export { N as NumberComparer, S as StringComparer } from '../numberComparer-47fa4d1b.js';
export { g as getMostSuitableOrder } from '../getMostSuitableOrder-d0da2421.js';
export { c as chunkArray } from '../chunkArray-70717c9c.js';
export { g as groupBy } from '../groupBy-bc1de3e1.js';
export { H as HexColor, R as RgbColor, a as RgbaColor } from '../rgbaColor-dc84e7a0.js';
export { C as CommissionStatusColor, a as ContrastColor } from '../contrastColor-eea6b37b.js';
export { r as rgbToHex } from '../rgbToHex-44bd5ba7.js';
export { C as Color } from '../color-ca3e86bd.js';
export { D as DictionaryFilter } from '../dictionaryFilter-769f7408.js';
export { a as DictionarySelectKeys, D as DictionarySerializer } from '../dictionarySerializer-969da3d0.js';
export { a as DICTIONARY_DEFAULT_DISPLAY_SEQUENCE, D as DictionarySorter } from '../dictionarySorter-1f1c5424.js';
export { D as DictionaryTranslator } from '../dictionaryTranslator-6f7eced2.js';
export { D as DictionaryUtils } from '../dictionaryUtils-5efc68f5.js';
export { D as DOMPURIFY_CONFIG, a as PrintFrame, P as Printer, g as getSafeExternalContent, p as printScreen } from '../printScreen-93afd739.js';
export { C as ComparisonDateUtils, D as DateUtils, a as DurationDateUtils, P as PeriodDateUtils, S as SerializationDateUtils, T as TimeDateUtils, b as TimezoneDateUtils, c as TransformationsDateUtils } from '../timezone-28b65d17.js';
export { A as API_DATE_FORMAT, f as API_DATE_TIME_FORMAT, a as API_DATE_TIME_UTC_FORMAT, d as API_MATCH_FULL_BIRTHDAY_FORMAT, e as API_MATCH_PARTIAL_BIRTHDAY_FORMAT, g as API_TIME_FORMAT, C as ComparisonDateUtilsDeprecated, h as DISPLAY_DATE_FORMAT, i as DISPLAY_TIME_FORMAT, j as DISPLAY_TIME_FORMAT_12_HOURS, c as DateComparePrecision, b as DateUtilsDeprecated, D as DurationDateUtilsDeprecated, k as DurationFormat, L as LogicalConditions, P as PeriodDateUtilsDeprecated, S as SerializationDateUtilsDeprecated } from '../duration-1387802c.js';
export { D as DateUnit } from '../unit-e9fb035f.js';
export { D as DateRange } from '../DateRange-749d733e.js';
export { R as RegExpUtils } from '../index-0e1c9a05.js';
export { d as additionalWordSeparators, c as capitalize, g as getByteLength, f as getEscapedRegexSpecialCharacter, h as getEscapedRegexString, j as getWordSeparatorsForMatcher, b as isEmptyString, a as isMinimumTextToSendQuery, e as isRegexSpecialCharacter, i as isUpperCase, k as startsWithMatchNormalizedText, s as stringNormalize, t as trim, u as uncapitalize } from '../startsWithMatchNormalizedText-fb915369.js';
export { g as getErrorMessage } from '../getErrorMessage-f1ecd956.js';
export { i as isUUIDV4, u as uuidv4 } from '../uuidv4-3e38baa4.js';
export { g as guid } from '../guid-de6240ab.js';
import { c as createBrowserHistory, u as utils$1, s as stringify_1, f as formats$1 } from '../stringify-fe192667.js';
export { V as ValidIpAddressRegex, d as deepEquals, i as isValidIpAddress } from '../stringify-fe192667.js';
export { a as SCROLL_DEFAULT_BOUNDARY_THRESHOLD, S as ScrollBoundaryTools, d as debounce } from '../scrollBoundaryTools-4fc80d69.js';
export { d as downloadFileWithText } from '../downloadFileWithText-58270282.js';
export { S as ScrollUtils } from '../scrollUtils-924b3ce4.js';
export { i as isDefined } from '../isDefined-e6be1a49.js';
export { r as repeatableCall } from '../repeatableCall-a4f25d0c.js';
export { g as getGlobalACPNamespace } from '../globalAcpNamespace-f56d6e59.js';
export { g as getPlainTextFromHtmlStrings } from '../getPlainTextFromHtmlStrings-c87a0ff8.js';
export { i as isDarkBackground } from '../isDarkBackground-b7650703.js';
export { c as checkMedia } from '../checkMedia-85eab069.js';
export { t as toHexColor } from '../toHexColor-36a0dbbc.js';
export { d as doesContainCreditCardPattern } from '../doesContainCreditCardPattern-d196b5d0.js';
import 'moment';
import '../translator-c311ba49.js';
import '../purify-ad604b51.js';
import '../_commonjsHelpers-ced4e05c.js';
import '../mathUtils-f6581b44.js';
import '../mathProportionCalculator-1f90427a.js';
import '../mathRandomizer-15b806e5.js';
import '../mathPrecisionTool-7b91146f.js';

const iframeClass = 'pdf-iframe';
const printBlob = (myBlob) => {
    const objectURL = URL.createObjectURL(myBlob);
    const iframe = document.createElement('iframe');
    iframe.className = iframeClass;
    document.body.append(iframe);
    iframe.src = objectURL;
    URL.revokeObjectURL(iframe.src);
    iframe.onload = () => {
        iframe.contentWindow.print();
    };
};
const downloadBlob = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', () => URL.revokeObjectURL(link.href), {
        once: true,
    });
};
const openBlobInNewTab = (blob) => {
    const fileObjectURL = URL.createObjectURL(blob);
    window.open(fileObjectURL, '_blank');
};
const removeAllPdfIFrames = () => {
    const elements = document.getElementsByClassName(iframeClass);
    while (elements && elements[0]) {
        elements[0].parentNode.removeChild(elements[0]);
    }
};

const updateDocumentTitle = (title) => {
    if (title) {
        document.title = title;
    }
};
const getDocumentTitleWithPrefix = (prefix, title) => {
    if (title && prefix) {
        return `${prefix} - ${title}`;
    }
    return undefined;
};

let historyInstance;
const getHistoryInstance = () => {
    if (!historyInstance) {
        historyInstance = createBrowserHistory();
    }
    return historyInstance;
};
const clearHistoryInstance = () => {
    historyInstance = undefined;
};

async function wait(milliseconds) {
    await new Promise((resolve) => setTimeout(resolve, milliseconds));
}

const isEmpty = (element) => {
    if (typeof element === 'boolean') {
        return !element;
    }
    if (element === null || element === undefined || Number.isNaN(element)) {
        return true;
    }
    if (Array.isArray(element) || typeof element === 'string') {
        return element.length === 0;
    }
    if (Object.keys(element).length === 0 &&
        typeof element === 'object') {
        return true;
    }
    return false;
};

function isObject(element) {
    return !!element && typeof element === 'object' && !Array.isArray(element);
}

var utils = utils$1;

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

var parse$1 = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

var stringify = stringify_1;
var parse = parse$1;
var formats = formats$1;

var lib = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

const stringMarker = '_';
function decodeQueryParamComponent(URIpart) {
    return decodeURIComponent(URIpart.replace(/\+/g, ' '));
}
function decodeQueryParam(URIpart) {
    return decodeURI(URIpart.replace(/\+/g, ' '));
}
function containsEncodedComponents(str) {
    return decodeURI(str) !== decodeURIComponent(str);
}
function containsDecodedComponents(str) {
    return encodeURI(str) !== encodeURIComponent(str);
}
function encoder(str) {
    if (typeof str === 'string') {
        if (containsDecodedComponents(str)) {
            return `${stringMarker}${encodeURIComponent(str)}${stringMarker}`;
        }
        return `${stringMarker}${encodeURI(str)}${stringMarker}`;
    }
    return str;
}
function decoder(str) {
    if (str.startsWith(stringMarker) && str.endsWith(stringMarker)) {
        if (containsEncodedComponents(str)) {
            return decodeQueryParamComponent(str
                .substring(stringMarker.length)
                .substring(0, str.length - stringMarker.length * 2));
        }
        return decodeQueryParam(str
            .substring(stringMarker.length)
            .substring(0, str.length - stringMarker.length * 2));
    }
    try {
        return JSON.parse(str);
    }
    catch (_a) {
        return str;
    }
}
/**
 * @deprecated Use `serializeToUrlSearchString`
 */
function setUrlSearchParams(history, nextQueryObject) {
    const prevSearchObject = parseUrlSearchParams(history);
    const obj = Object.assign(Object.assign({}, prevSearchObject), nextQueryObject);
    const queryString = serializeToUrlSearchString(obj);
    history.replace({
        pathname: history.location.pathname,
        search: `?${queryString}`,
    });
}
function serializeToUrlSearchString(queryObject) {
    const options = {
        encoder,
        encodeValuesOnly: true,
        arrayFormat: 'brackets',
    };
    return lib.stringify(queryObject, options);
}
/**
 * @deprecated Use `deserializeUrlSearchString`
 */
function parseUrlSearchParams(history) {
    const searchString = history.location.search;
    return deserializeUrlSearchString(searchString);
}
function deserializeUrlSearchString(urlSearchString) {
    const searchString = urlSearchString.replace(/^\?/, '');
    return lib.parse(searchString, { decoder });
}

const safeCheck = (func) => {
    try {
        return !!func();
    }
    catch (e) {
        return false;
    }
};
const safeGet = (func) => {
    try {
        return func();
    }
    catch (e) {
        return undefined;
    }
};

const getApplicationPassedInParams = (controller) => controller.namespace;

const getRadixPointFromCurrencyFormat = (currencyFormat) => {
    const regEx = /^#+[^#]#+[^#]/;
    const result = regEx.exec(currencyFormat || '') || [];
    return (result[0] || '').slice(-1) || undefined;
};
const getGroupSeparatorFromCurrencyFormat = (currencyFormat) => {
    const regEx = /^#+[^#]/;
    const result = regEx.exec(currencyFormat || '') || [];
    return (result[0] || '').slice(-1) || undefined;
};

const propertyNameOf = (name) => {
    return name;
};

export { clearHistoryInstance, deserializeUrlSearchString, downloadBlob, getApplicationPassedInParams, getDocumentTitleWithPrefix, getGroupSeparatorFromCurrencyFormat, getHistoryInstance, getRadixPointFromCurrencyFormat, isEmpty, isObject, openBlobInNewTab, parseUrlSearchParams, printBlob, propertyNameOf, removeAllPdfIFrames, safeCheck, safeGet, serializeToUrlSearchString, setUrlSearchParams, updateDocumentTitle, wait };
//# sourceMappingURL=index.js.map
